module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-180x180-8fd843571c9b2b855fe22154e84a2c11.png";